import { setOnerror } from "@ember/-internals/error-handling";
import Bugsnag from "@bugsnag/js";
import ENV from "glesys-controlpanel/config/environment";

export function initialize(appInstance) {
  let session = appInstance.lookup("service:session");

  setOnerror((error) => {
    let user = session.currentUser;
    if (ENV.environment === "production") {
      Bugsnag.setUser(user?.id, user?.username, user?.name);

      Bugsnag.notify(error);
    }
  });
}

export default {
  name: "bugsnag",
  initialize,
};
